<template>
  <div class="image-gallery">
    <div class="image-container">
      <div
        v-for="(image, index) in images"
        :key="index"
        class="image-item"
        @click="openLightbox(index)"
      >
        <img :src="image.src" :alt="image.alt" class="thumbnail" />
      </div>
    </div>

    <!-- Modal to show enlarged image -->
    <b-modal
      id="image-lightbox"
      size="lg"
      :visible.sync="isLightboxOpen"
      hide-footer
      centered
      @shown="onModalShown"
      @hidden="isLightboxOpen = false"
    >
      <div class="lightbox-content">
        <img :src="currentImage.src" :alt="currentImage.alt" class="lightbox-img" />
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ImageGallery",
  data() {
    return {
      isLightboxOpen: false,
      currentIndex: 0,
      images: [
        { src: require('@/assets/images/activity-scene-1.jpg'), alt: "Image 1" },
        { src: require('@/assets/images/activity-scene-2.jpg'), alt: "Image 2" },
        { src: require('@/assets/images/activity-scene-3.jpg'), alt: "Image 3" },
        { src: require('@/assets/images/activity-scene-5.jpg'), alt: "Image 5" },
        { src: require('@/assets/images/activity-scene-6.jpg'), alt: "Image 6" },
        // { src: require('@/assets/images/activity-scene-4.jpg'), alt: "Image 3" },
        // Add more images as needed
      ],
    };
  },
  computed: {
    currentImage() {
      return this.images[this.currentIndex];
    },
  },
  methods: {
    openLightbox(index) {
      console.log(this.isLightboxOpen);
      this.currentIndex = index;
      this.isLightboxOpen = true;
      console.log(this.isLightboxOpen);
    },
    onModalShown() {
      // Optional: Focus on the image inside modal when opened
      this.$nextTick(() => {
        document.querySelector(".lightbox-img").focus();
      });
    },
  },
};
</script>

<style scoped>
.image-gallery {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  overflow: hidden;
}

.image-container {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 16px;
  padding: 16px;
  scroll-behavior: smooth;
}

.image-item {
  cursor: pointer;
  transition: transform 0.3s ease;
  flex: 0 0 auto; /* Prevent items from shrinking or stretching */
  /* width: 300px; */
}

.image-item:hover {
  transform: scale(1.05); /* Slight zoom on hover */
}

.thumbnail {
  height: 300px;
  width: auto;
  flex-shrink: 0;
  border-radius: 8px;
  object-fit: cover;
}

.lightbox-content {
  text-align: center;
}

.lightbox-img {
  max-width: 90%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/ImageGallery.vue